import address from './address'
import review from './review'
import columns from './columns'
import signature from './signature'
import state from './state'
import zip from './zip'

export default {
  address,
  review,
  columns,
  state,
  signature,
  zip
}
